import Phaser from 'phaser';
import { ModalSheet } from './modal-sheet';
import { ModalSheetConfig } from './modal-sheet/modal-sheet.types';

export class RankSheet<TemplateData> extends ModalSheet<TemplateData> {
  constructor(
    scene: Phaser.Scene,
    config: ModalSheetConfig<TemplateData> = {},
  ) {
    super(scene, { ...config, iconKey: 'rank' });
  }
  protected createContent(content: Phaser.GameObjects.Container): void {
    const element = this.createDomContent('leaderboard', this.cfg.templateData);

    content.add([element]);
  }
}
